module.exports = __webpack_public_path__ + "img/04.100e6d1e.png";